import {
  DefaultActionsErrorView,
  ErrorBoundary,
  LoaderCentered,
} from '@modules/components';
import { Suspense } from 'react';
import { Outlet } from 'react-router-dom';
import styled from 'styled-components';
import DefaultLayout from './Default';

const StyledMain = styled.main`
  width: 100vw;
  height: 100vh;
  max-height: -webkit-fill-available;
  display: flex;
  justify-content: center;
  align-items: center;
`;

function Layout() {
  return (
    <StyledMain>
      <DefaultLayout>
        <ErrorBoundary fallback={<DefaultActionsErrorView />}>
          <Suspense fallback={<LoaderCentered />}>
            <Outlet />
          </Suspense>
        </ErrorBoundary>
      </DefaultLayout>
    </StyledMain>
  );
}

export default Layout;
